import styled, { keyframes } from 'styled-components'

export const Svg = styled.svg.attrs({
	viewBox: '-16 -16 32 32',
})`
	animation: 1.4s linear infinite ${keyframes`
		0% {
			transform: rotate(0deg);
		}

		100% {
			transform: rotate(360deg);
		}
	`};
`
